module.exports = __webpack_public_path__ + "img/minCourse.b7c02b1b.png";